<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="mt-5">
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardBody>
                                <CTabs variant="tabs" :active-tab="0">
                                    <!-- General -->
                                    <CTab :title="$t('general')">
                                        <CCard bodyWrapper>
                                            <CInput
                                                :isValid="checkIfValid('name')"
                                                :value.sync="
                                                    $v.form.name.$model
                                                "
                                                :label="$t('name')"
                                                :placeholder="
                                                    $t('enter_the_name')
                                                "
                                                :invalidFeedback="
                                                    $t('name_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />

                                            <LInputRadioGroup
                                                :checked.sync="
                                                    $v.form.advance_validation
                                                        .$model
                                                "
                                                :options="[
                                                    {
                                                        value: true,
                                                        label: 'Yes',
                                                    },
                                                    {
                                                        value: false,
                                                        label: 'No',
                                                    },
                                                ]"
                                                size="sm"
                                                :label="
                                                    $t('advance_validation')
                                                "
                                                :inline="true"
                                                :horizontal="default_horizontal"
                                            />

                                            <CSelect
                                                :value.sync="
                                                    $v.form.shipping_method
                                                        .$model
                                                "
                                                :options="[
                                                    {
                                                        value: 'c56eeb8a-07fc-4d5f-9a6d-e23608179f38',
                                                        label: $t('method_api'),
                                                    },
                                                    {
                                                        value: '25e002d8-c055-4d57-8be1-cba76eb56a21',
                                                        label: $t(
                                                            'method_email'
                                                        ),
                                                    },
                                                    {
                                                        value: '6d5eb8dc-f006-4b09-b914-09fa17c6bf59',
                                                        label: $t(
                                                            'method_sftp'
                                                        ),
                                                    },
                                                    {
                                                        value: '1346c8a9-d04e-4ba2-b4ec-0142e706cfa6',
                                                        label: $t(
                                                            'method_api_download'
                                                        ),
                                                    },
                                                ]"
                                                size="sm"
                                                :horizontal="default_horizontal"
                                                :label="$t('shipping_method')"
                                            />

                                            

                                            <FormSection
                                                v-if="
                                                form.shipping_method ==
                                                    '25e002d8-c055-4d57-8be1-cba76eb56a21' ||
                                                form.shipping_method ==
                                                    '6d5eb8dc-f006-4b09-b914-09fa17c6bf59'
                                                "
                                            >
                                                <FormSectionDescription
                                                    :title="
                                                        $t('Daily hour execute')
                                                    "
                                                    :sortDescription="
                                                        $t(
                                                            'In this section you can configure the time at which the shipment will be executed.'
                                                        )
                                                    "
                                                />
                                                <CInput
                                                    :value.sync="
                                                        $v.form.daily_hour_execute
                                                            .$model
                                                    "
                                                    type="number"
                                                    :label="
                                                        $t('daily_hour_execute')
                                                    "
                                                    :placeholder="
                                                        $t('enter_a_hour')
                                                    "
                                                    :invalidFeedback="
                                                        $t(
                                                            'Hour between 0 - 24 is required'
                                                        )
                                                    "
                                                    :horizontal="default_horizontal"
                                                    size="sm"
                                                />
                                            </FormSection>

                                            <FormSection
                                                v-if="
                                                form.shipping_method ==
                                                    '25e002d8-c055-4d57-8be1-cba76eb56a21' ||
                                                form.shipping_method ==
                                                    '6d5eb8dc-f006-4b09-b914-09fa17c6bf59'
                                                "
                                            >
                                                <FormSectionDescription
                                                    :title="
                                                        $t('Week days execute')
                                                    "
                                                    :sortDescription="
                                                        $t(
                                                            'In this section you can configure the days of the week on which the shipment must be executed.'
                                                        )
                                                    "
                                                />

                                                <SelectTags
                                                    :placeholder="
                                                        $t('select_weekdays')
                                                    "
                                                    size="sm"
                                                    :value.sync="
                                                        weekDaysExecute
                                                    "
                                                    :options="
                                                        $options.options
                                                            .weekDays
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    :label="
                                                        $t('week_days_execute')
                                                    "
                                                />
                                            </FormSection>
                                        </CCard>
                                    </CTab>
                                    <CTab :title="$t('acceptance_filter')">
                                        <CCard>
                                            <CCardBody>
                                                <!-- Table acceptance filter -->
                                                <CModal
                                                    :title="$t('options_list')"
                                                    color="secondary"
                                                    :show.sync="
                                                        modals.optionsList.show
                                                    "
                                                    :closeOnBackdrop="false"
                                                >
                                                    <CContainer fluid>
                                                        <CTextarea
                                                            :placeholder="
                                                                $t(
                                                                    'Add list of options'
                                                                )
                                                            "
                                                            :value.sync="
                                                                modals
                                                                    .optionsList
                                                                    .data
                                                                    .optionsValue
                                                            "
                                                            size="sm"
                                                        >
                                                        </CTextarea>
                                                    </CContainer>
                                                    <template #footer>
                                                        <!-- Button close modal -->
                                                        <ButtonClose
                                                            @click="
                                                                closeModal({
                                                                    modalName:
                                                                        'optionsList',
                                                                })
                                                            "
                                                        />

                                                        <!-- Button save modal -->
                                                        <ButtonSave
                                                            @click="
                                                                saveOptionsList()
                                                            "
                                                        />
                                                    </template>
                                                </CModal>
                                                <CustomTable
                                                    :items="
                                                        tables.actionFilter
                                                            .items
                                                    "
                                                    :fields="
                                                        traslateLabels(
                                                            tables.actionFilter
                                                                .fields
                                                        )
                                                    "
                                                    :resizable="false"
                                                >
                                                    <template
                                                        #fieldName="{ index }"
                                                    >
                                                        <SelectFields
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    'actionFilter',
                                                                    'fieldName',
                                                                    index
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables[
                                                                    'actionFilter'
                                                                ].items.$each[
                                                                    index
                                                                ].fieldName
                                                                    .$model
                                                            "
                                                            v-bind="
                                                                defaultSelectInTableConfig
                                                            "
                                                            :advanceMode="
                                                                stringToBoolean(
                                                                    form.advance_validation
                                                                )
                                                            "
                                                            typeSelect="SearchSelect"
                                                            uses="DELIVERY"
                                                            :optionsValue="
                                                                stringToBoolean(
                                                                    form.advance_validation
                                                                ) == true
                                                                    ? 'code'
                                                                    : 'name'
                                                            "
                                                        />
                                                    </template>
                                                    <template
                                                        #fieldType="{ index }"
                                                    >
                                                        <CSelect
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    'actionFilter',
                                                                    'fieldType',
                                                                    index
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables[
                                                                    'actionFilter'
                                                                ].items.$each[
                                                                    index
                                                                ].fieldType
                                                                    .$model
                                                            "
                                                            :options="
                                                                traslateLabels(
                                                                    $options
                                                                        .options
                                                                        .FieldTypeOptions
                                                                )
                                                            "
                                                            v-bind="
                                                                defaultSelectInTableConfig
                                                            "
                                                        />
                                                    </template>
                                                    <template
                                                        #condition="{ index }"
                                                    >
                                                        <CSelect
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    'actionFilter',
                                                                    'condition',
                                                                    index
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables[
                                                                    'actionFilter'
                                                                ].items.$each[
                                                                    index
                                                                ].condition
                                                                    .$model
                                                            "
                                                            :options="
                                                                traslateLabels(
                                                                    $options
                                                                        .options
                                                                        .filterType
                                                                )
                                                            "
                                                            v-bind="
                                                                defaultSelectInTableConfig
                                                            "
                                                        />
                                                    </template>
                                                    <template
                                                        #value="{ index }"
                                                    >
                                                        <CButton
                                                            v-if="
                                                                getFilterCondition(
                                                                    index
                                                                ) == 'list' ||
                                                                getFilterCondition(
                                                                    index
                                                                ) ==
                                                                    'not_in_list'
                                                            "
                                                            :block="true"
                                                            color="secondary"
                                                            variant="outline"
                                                            @click="
                                                                openModal({
                                                                    modalName:
                                                                        'optionsList',
                                                                    data: {
                                                                        idItemSelected:
                                                                            index,
                                                                    },
                                                                    callback:
                                                                        initModalOptionsList,
                                                                })
                                                            "
                                                        >
                                                            {{ $t("options") }}
                                                        </CButton>
                                                        <CInput
                                                            v-else
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    'actionFilter',
                                                                    'value',
                                                                    index
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables[
                                                                    'actionFilter'
                                                                ].items.$each[
                                                                    index
                                                                ].value.$model
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'enter_the_value'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'value_is_required'
                                                                )
                                                            "
                                                            class="mb-0"
                                                            size="sm"
                                                        />
                                                    </template>
                                                    <template
                                                        #options="{ index }"
                                                    >
                                                        <div
                                                            class="table-options"
                                                        >
                                                            <ButtonTrash
                                                                @click="
                                                                    deleteItemToTable(
                                                                        'actionFilter',
                                                                        index
                                                                    )
                                                                "
                                                            />
                                                        </div>
                                                    </template>
                                                    <template #no-items-view>
                                                        <div
                                                            class="block-no-items section"
                                                        >
                                                            <h2
                                                                class="section__title text-no-items"
                                                            >
                                                                {{
                                                                    $t(
                                                                        "add_configuration"
                                                                    )
                                                                }}
                                                            </h2>
                                                            <ButtonAdd
                                                                @click="
                                                                    addItemToTable(
                                                                        'actionFilter'
                                                                    )
                                                                "
                                                            />
                                                        </div>
                                                    </template>
                                                </CustomTable>
                                            </CCardBody>
                                            <CCardFooter
                                                v-if="
                                                    tables.actionFilter.items
                                                        .length > 0
                                                "
                                            >
                                                <ButtonAdd
                                                    @click="
                                                        addItemToTable(
                                                            'actionFilter'
                                                        )
                                                    "
                                                />
                                            </CCardFooter>
                                        </CCard>
                                    </CTab>
                                    <CTab
                                        :title="$t('api_configuration')"
                                        :disabled="
                                            $v.form.shipping_method.$model !=
                                            'c56eeb8a-07fc-4d5f-9a6d-e23608179f38'
                                        "
                                    >
                                        <CCard
                                            v-for="(
                                                api_configuration, index
                                            ) in api_configuration_list"
                                            :key="index"
                                            class="my-4"
                                        >
                                            <CCardHeader>
                                                {{
                                                    $t(api_configuration.label)
                                                }}
                                            </CCardHeader>
                                            <!-- Configuration endpoint -->
                                            <CCardBody
                                                v-if="
                                                    api_configuration.key ==
                                                    'configuration_endpoint'
                                                "
                                            >
                                                <h6>
                                                    {{
                                                        $t(
                                                            "configuration_endpoint_description"
                                                        )
                                                    }}
                                                </h6>
                                                <CRow :form="true">
                                                    <CCol sm="2">
                                                        <CSelect
                                                            :isValid="
                                                                checkIfValid(
                                                                    'method'
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.form.method
                                                                    .$model
                                                            "
                                                            :options="
                                                                traslateLabels(
                                                                    $options
                                                                        .options
                                                                        .methods
                                                                )
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'select_a_method'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'method_is_required'
                                                                )
                                                            "
                                                            size="sm"
                                                        />
                                                    </CCol>
                                                    <CCol sm="10">
                                                        <CInput
                                                            :isValid="
                                                                checkIfValid(
                                                                    'url'
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.form.url
                                                                    .$model
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'https://_o_http://'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'url_is_required'
                                                                )
                                                            "
                                                            type="url"
                                                            size="sm"
                                                        />
                                                    </CCol>
                                                </CRow>
                                            </CCardBody>
                                            <!-- Shipping format -->
                                            <CCardBody
                                                class="py-2"
                                                v-else-if="
                                                    api_configuration.key ==
                                                    'shipping_format'
                                                "
                                            >
                                                <CSelect
                                                    :isValid="
                                                        checkIfValid(
                                                            'sendFormat'
                                                        )
                                                    "
                                                    :value.sync="
                                                        $v.form.sendFormat
                                                            .$model
                                                    "
                                                    :options="
                                                        traslateLabels(
                                                            $options.options
                                                                .shippingFormat
                                                        )
                                                    "
                                                    :label="
                                                        $t('shipping_format')
                                                    "
                                                    :placeholder="
                                                        $t(
                                                            'enter_the_shipping_format'
                                                        )
                                                    "
                                                    :invalidFeedback="
                                                        $t(
                                                            'shipping_format_is_required'
                                                        )
                                                    "
                                                    size="sm"
                                                />
                                            </CCardBody>
                                            <CCardBody
                                                v-else-if="
                                                    api_configuration.key ==
                                                    'multiFieldMapping'
                                                "
                                            >
                                                <p
                                                    v-if="
                                                        api_configuration.description
                                                    "
                                                >
                                                    {{
                                                        $t(
                                                            api_configuration.description
                                                        )
                                                    }}
                                                </p>
                                                <CCMultiFieldMapping
                                                    :value.sync="
                                                        form.multiFieldMapping
                                                    "
                                                ></CCMultiFieldMapping>
                                            </CCardBody>

                                            <CCardBody
                                                class="py-2"
                                                v-else-if="
                                                    api_configuration.key ==
                                                    'payload'
                                                "
                                            >
                                                <CSwitch
                                                    :checked.sync="
                                                        $v.form.payloadActive
                                                            .$model
                                                    "
                                                    color="primary"
                                                    name="action"
                                                    shape="pill"
                                                    variant="3d"
                                                    size="sm"
                                                />
                                                <CTextarea
                                                    :isValid="
                                                        checkIfValid(
                                                            'payloadContent'
                                                        )
                                                    "
                                                    :value.sync="payloadContent"
                                                    size="sm"
                                                    rows="15"
                                                />
                                            </CCardBody>
                                            <CCardBody
                                                v-else-if="
                                                    api_configuration.type ==
                                                    'table'
                                                "
                                            >
                                                <!-- Descripciones -->
                                                <h6
                                                    v-if="
                                                        api_configuration.description
                                                    "
                                                >
                                                    {{
                                                        $t(
                                                            api_configuration.description
                                                        )
                                                    }}
                                                </h6>
                                                <CustomTable
                                                    :addTableClasses="[
                                                        'table--sm',
                                                    ]"
                                                    :items="
                                                        tables[
                                                            api_configuration
                                                                .key
                                                        ].items
                                                    "
                                                    :fields="
                                                        traslateLabels(
                                                            tables[
                                                                api_configuration
                                                                    .key
                                                            ].fields
                                                        )
                                                    "
                                                    :resizable="false"
                                                    hover
                                                    border
                                                    striped
                                                >
                                                    <!-- Options -->
                                                    <template
                                                        #options="{ index }"
                                                    >
                                                        <CButton
                                                            color="success"
                                                            variant="outline"
                                                            square
                                                            size="sm"
                                                            @click="
                                                                toggleDetails(
                                                                    'mapping',
                                                                    index
                                                                )
                                                            "
                                                            v-if="
                                                                api_configuration.key ==
                                                                'mapping'
                                                            "
                                                        >
                                                            <CIcon
                                                                class="icon"
                                                                :content="
                                                                    $options
                                                                        .icons
                                                                        .cilPencil
                                                                "
                                                            />
                                                        </CButton>
                                                        <ButtonTrash
                                                            @click="
                                                                deleteItemToTable(
                                                                    api_configuration.key,
                                                                    index
                                                                )
                                                            "
                                                        />
                                                    </template>
                                                    <!-- No items view -->
                                                    <template #no-items-view>
                                                        <div
                                                            class="block-no-items section"
                                                        >
                                                            <h2
                                                                class="text-no-items section__title"
                                                            >
                                                                {{
                                                                    $t(
                                                                        "add_configuration"
                                                                    )
                                                                }}
                                                            </h2>
                                                            <ButtonAdd
                                                                @click="
                                                                    addItemToTable(
                                                                        api_configuration.key
                                                                    )
                                                                "
                                                            />
                                                        </div>
                                                    </template>

                                                    <!-- Query params -->
                                                    <template
                                                        #queryName="{ index }"
                                                    >
                                                        <CInput
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    api_configuration.key,
                                                                    'queryName',
                                                                    index
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables[
                                                                    api_configuration
                                                                        .key
                                                                ].items.$each[
                                                                    index
                                                                ].queryName
                                                                    .$model
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'enter_the_query_name'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'query_name_is_required'
                                                                )
                                                            "
                                                            size="sm"
                                                        />
                                                    </template>
                                                    <template
                                                        #queryValue="{ index }"
                                                    >
                                                        <CInput
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    api_configuration.key,
                                                                    'queryValue',
                                                                    index
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables[
                                                                    api_configuration
                                                                        .key
                                                                ].items.$each[
                                                                    index
                                                                ].queryValue
                                                                    .$model
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'enter_the_query_value'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'query_value_is_required'
                                                                )
                                                            "
                                                            size="sm"
                                                        />
                                                    </template>
                                                    <template
                                                        #queryMethod="{ index }"
                                                    >
                                                        <CSelect
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    api_configuration.key,
                                                                    'queryMethod',
                                                                    index
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables[
                                                                    api_configuration
                                                                        .key
                                                                ].items.$each[
                                                                    index
                                                                ].queryMethod
                                                                    .$model
                                                            "
                                                            :options="
                                                                traslateLabels(
                                                                    $options
                                                                        .options
                                                                        .methods
                                                                )
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'select_a_query_method'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'query_method_is_required'
                                                                )
                                                            "
                                                            size="sm"
                                                        />
                                                    </template>
                                                    <template
                                                        #fieldMappingMethod="{
                                                            index,
                                                        }"
                                                    >
                                                        <CSelect
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    api_configuration.key,
                                                                    'fieldMappingMethod',
                                                                    index
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables[
                                                                    api_configuration
                                                                        .key
                                                                ].items.$each[
                                                                    index
                                                                ]
                                                                    .fieldMappingMethod
                                                                    .$model
                                                            "
                                                            :options="
                                                                traslateLabels(
                                                                    $options
                                                                        .options
                                                                        .methods
                                                                )
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'select_a_query_method'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'query_method_is_required'
                                                                )
                                                            "
                                                            size="sm"
                                                        />
                                                    </template>

                                                    <!-- Field mapping -->
                                                    <template
                                                        #fieldMappingId="{
                                                            index,
                                                        }"
                                                    >
                                                        <SelectFields
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    api_configuration.key,
                                                                    'fieldMappingId',
                                                                    index
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables[
                                                                    api_configuration
                                                                        .key
                                                                ].items.$each[
                                                                    index
                                                                ][
                                                                    'fieldMappingId'
                                                                ].$model
                                                            "
                                                            v-bind="
                                                                defaultSelectInTableConfig
                                                            "
                                                            :advanceMode="
                                                                stringToBoolean(
                                                                    form.advance_validation
                                                                )
                                                            "
                                                            uses="DELIVERY"
                                                            :optionsValue="
                                                                form.advance_validation ==
                                                                true
                                                                    ? 'code'
                                                                    : 'name'
                                                            "
                                                        />
                                                    </template>
                                                    <template
                                                        #fieldMappingValue="{
                                                            index,
                                                        }"
                                                    >
                                                        <CInput
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    api_configuration.key,
                                                                    'fieldMappingValue',
                                                                    index
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables[
                                                                    api_configuration
                                                                        .key
                                                                ].items.$each[
                                                                    index
                                                                ][
                                                                    'fieldMappingValue'
                                                                ].$model
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'enter_the_field_mapping_value'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'field_mapping_value_is_required'
                                                                )
                                                            "
                                                            size="sm"
                                                        />
                                                    </template>
                                                    <template
                                                        v-if="
                                                            api_configuration.key ==
                                                            'mapping'
                                                        "
                                                        #details="{
                                                            item,
                                                            index,
                                                        }"
                                                    >
                                                        <CCollapse
                                                            :show="
                                                                Boolean(
                                                                    item._toggled
                                                                )
                                                            "
                                                        >
                                                            <CCardBody>
                                                                <CRow>
                                                                    <CCol
                                                                        col="3"
                                                                    >
                                                                        <CInputCheckbox
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    api_configuration.key,
                                                                                    'fieldActiveFormat',
                                                                                    index
                                                                                )
                                                                            "
                                                                            :checked.sync="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldActiveFormat'
                                                                                ]
                                                                                    .$model
                                                                            "
                                                                            :label="
                                                                                $t(
                                                                                    'enable_formatting'
                                                                                )
                                                                            "
                                                                        />
                                                                        <CSelect
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    api_configuration.key,
                                                                                    'fieldMappingFormatType',
                                                                                    index
                                                                                )
                                                                            "
                                                                            :value.sync="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingFormatType'
                                                                                ]
                                                                                    .$model
                                                                            "
                                                                            :options="
                                                                                traslateLabels(
                                                                                    $options
                                                                                        .options
                                                                                        .mappingFormatType
                                                                                )
                                                                            "
                                                                            :label="
                                                                                $t(
                                                                                    'acction'
                                                                                )
                                                                            "
                                                                            :placeholder="
                                                                                $t(
                                                                                    'select_a_field'
                                                                                )
                                                                            "
                                                                            :invalidFeedback="
                                                                                $t(
                                                                                    'field_mapping_format_type_is_required'
                                                                                )
                                                                            "
                                                                            size="sm"
                                                                        />
                                                                    </CCol>
                                                                    <CCol
                                                                        col="9"
                                                                    >
                                                                        <CInput
                                                                            v-if="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingFormatType'
                                                                                ]
                                                                                    .$model ==
                                                                                'mask'
                                                                            "
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    api_configuration.key,
                                                                                    'fieldMappingMask',
                                                                                    index
                                                                                )
                                                                            "
                                                                            :value.sync="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingMask'
                                                                                ]
                                                                                    .$model
                                                                            "
                                                                            :label="
                                                                                $t(
                                                                                    'apply_mask'
                                                                                )
                                                                            "
                                                                            :placeholder="
                                                                                $t(
                                                                                    'enter_the_mask'
                                                                                )
                                                                            "
                                                                            :invalidFeedback="
                                                                                $t(
                                                                                    'apply_mask_is_required'
                                                                                )
                                                                            "
                                                                            size="sm"
                                                                        />
                                                                        <div
                                                                            v-else-if="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingFormatType'
                                                                                ]
                                                                                    .$model ==
                                                                                    'format_date' ||
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingFormatType'
                                                                                ]
                                                                                    .$model ==
                                                                                    'now'
                                                                            "
                                                                        >
                                                                            <CSelect
                                                                                :isValid="
                                                                                    checkIfFormTableValid(
                                                                                        api_configuration.key,
                                                                                        'fieldMappingFormatDateType',
                                                                                        index
                                                                                    )
                                                                                "
                                                                                :value.sync="
                                                                                    $v
                                                                                        .tables[
                                                                                        api_configuration
                                                                                            .key
                                                                                    ]
                                                                                        .items
                                                                                        .$each[
                                                                                        index
                                                                                    ][
                                                                                        'fieldMappingFormatDateType'
                                                                                    ]
                                                                                        .$model
                                                                                "
                                                                                :options="
                                                                                    $options
                                                                                        .options
                                                                                        .dateFormat
                                                                                "
                                                                                :label="
                                                                                    $t(
                                                                                        'date_format'
                                                                                    )
                                                                                "
                                                                                :placeholder="
                                                                                    $t(
                                                                                        'select_a_date_format'
                                                                                    )
                                                                                "
                                                                                :invalidFeedback="
                                                                                    $t(
                                                                                        'date_format_is_required'
                                                                                    )
                                                                                "
                                                                                size="sm"
                                                                            />
                                                                            <SelectAsync
                                                                                :isValid="
                                                                                    checkIfFormTableValid(
                                                                                        api_configuration.key,
                                                                                        'convertDateTimeZone',
                                                                                        index
                                                                                    )
                                                                                "
                                                                                :value.sync="
                                                                                    $v
                                                                                        .tables[
                                                                                        api_configuration
                                                                                            .key
                                                                                    ]
                                                                                        .items
                                                                                        .$each[
                                                                                        index
                                                                                    ][
                                                                                        'convertDateTimeZone'
                                                                                    ]
                                                                                        .$model
                                                                                "
                                                                                :options="[
                                                                                    'UTC',
                                                                                    'Europe/Madrid',
                                                                                    'Europe/Paris',
                                                                                    'Europe/Rome',
                                                                                ]"
                                                                                :label="
                                                                                    $t(
                                                                                        'Timezone'
                                                                                    )
                                                                                "
                                                                                :placeholder="
                                                                                    $t(
                                                                                        'Select a timezone'
                                                                                    )
                                                                                "
                                                                                :resetOption="
                                                                                    true
                                                                                "
                                                                                size="sm"
                                                                            />

                                                                            <CCInputExtraTime
                                                                                :label="
                                                                                    $t(
                                                                                        'Extra time'
                                                                                    )
                                                                                "
                                                                                :value.sync="
                                                                                    $v
                                                                                        .tables[
                                                                                        api_configuration
                                                                                            .key
                                                                                    ]
                                                                                        .items
                                                                                        .$each[
                                                                                        index
                                                                                    ][
                                                                                        'addTimeToDate'
                                                                                    ]
                                                                                        .$model
                                                                                "
                                                                                :horizontal="
                                                                                    true
                                                                                "
                                                                                size="sm"
                                                                            />
                                                                        </div>

                                                                        <CSelect
                                                                            v-else-if="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingFormatType'
                                                                                ]
                                                                                    .$model ==
                                                                                'timestamp'
                                                                            "
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    api_configuration.key,
                                                                                    'fieldMappingFormatHourType',
                                                                                    index
                                                                                )
                                                                            "
                                                                            :value.sync="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingFormatHourType'
                                                                                ]
                                                                                    .$model
                                                                            "
                                                                            :options="
                                                                                $options
                                                                                    .options
                                                                                    .timeFormat
                                                                            "
                                                                            :label="
                                                                                $t(
                                                                                    'time_format'
                                                                                )
                                                                            "
                                                                            :placeholder="
                                                                                $t(
                                                                                    'select_a_time_format'
                                                                                )
                                                                            "
                                                                            :invalidFeedback="
                                                                                $t(
                                                                                    'time_format_is_required'
                                                                                )
                                                                            "
                                                                            size="sm"
                                                                        />
                                                                        <CInput
                                                                            v-else-if="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingFormatType'
                                                                                ]
                                                                                    .$model ==
                                                                                'md5'
                                                                            "
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    api_configuration.key,
                                                                                    'fieldMappingValueReplace',
                                                                                    index
                                                                                )
                                                                            "
                                                                            :value.sync="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingValueReplace'
                                                                                ]
                                                                                    .$model
                                                                            "
                                                                            :label="
                                                                                $t(
                                                                                    'replace_spaces'
                                                                                )
                                                                            "
                                                                            :placeholder="
                                                                                $t(
                                                                                    'enter_the_replace_spaces'
                                                                                )
                                                                            "
                                                                            :invalidFeedback="
                                                                                $t(
                                                                                    'replace_spaces_is_required'
                                                                                )
                                                                            "
                                                                            size="sm"
                                                                        />
                                                                    </CCol>
                                                                </CRow>
                                                                <CRow>
                                                                    <CCol>
                                                                        <h5>
                                                                            {{
                                                                                $t(
                                                                                    "Adapter Values"
                                                                                )
                                                                            }}
                                                                        </h5>
                                                                        <p
                                                                            class="mb-0"
                                                                        >
                                                                            {{
                                                                                $t(
                                                                                    "You can adapter the values to send"
                                                                                )
                                                                            }}.
                                                                        </p>
                                                                        <ButtonBulk
                                                                            :value.sync="
                                                                                tables
                                                                                    .mapping
                                                                                    .items[
                                                                                    index
                                                                                ]
                                                                                    .fieldAdapter
                                                                            "
                                                                        />
                                                                        <CustomTable
                                                                            :items="
                                                                                tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items[
                                                                                    index
                                                                                ][
                                                                                    'fieldAdapter'
                                                                                ]
                                                                            "
                                                                            :resizable="
                                                                                false
                                                                            "
                                                                            :fields="[
                                                                                {
                                                                                    key: 'name',
                                                                                    label: 'name',
                                                                                },
                                                                                {
                                                                                    key: 'value',
                                                                                    label: 'value',
                                                                                },
                                                                                {
                                                                                    key: 'options',
                                                                                    label: 'options',
                                                                                    _style: 'width:10%',
                                                                                    _classes:
                                                                                        'text-center',
                                                                                },
                                                                            ]"
                                                                            hover
                                                                            border
                                                                            striped
                                                                        >
                                                                            <template
                                                                                #no-items-view
                                                                            >
                                                                                <div
                                                                                    class="block-no-items section"
                                                                                >
                                                                                    <h2
                                                                                        class="section__title text-no-items"
                                                                                    >
                                                                                        {{
                                                                                            $t(
                                                                                                "Add a fixed field"
                                                                                            )
                                                                                        }}
                                                                                    </h2>
                                                                                    <ButtonAdd
                                                                                        @click="
                                                                                            addItemToFieldAdapterTable(
                                                                                                index
                                                                                            )
                                                                                        "
                                                                                    />
                                                                                </div>
                                                                            </template>
                                                                            <template
                                                                                #under-table
                                                                            >
                                                                                <ButtonAdd
                                                                                    v-if="
                                                                                        tables[
                                                                                            api_configuration
                                                                                                .key
                                                                                        ]
                                                                                            .items[
                                                                                            index
                                                                                        ][
                                                                                            'fieldAdapter'
                                                                                        ] &&
                                                                                        tables[
                                                                                            api_configuration
                                                                                                .key
                                                                                        ]
                                                                                            .items[
                                                                                            index
                                                                                        ][
                                                                                            'fieldAdapter'
                                                                                        ]
                                                                                            .length >
                                                                                            0
                                                                                    "
                                                                                    @click="
                                                                                        addItemToFieldAdapterTable(
                                                                                            index
                                                                                        )
                                                                                    "
                                                                                />
                                                                            </template>
                                                                            <template
                                                                                #name="{
                                                                                    item,
                                                                                }"
                                                                            >
                                                                                <CInput
                                                                                    :placeholder="
                                                                                        $t(
                                                                                            'enter_file_name'
                                                                                        )
                                                                                    "
                                                                                    size="sm"
                                                                                    :value.sync="
                                                                                        item.name
                                                                                    "
                                                                                />
                                                                            </template>
                                                                            <template
                                                                                #value="{
                                                                                    item,
                                                                                }"
                                                                            >
                                                                                <CInput
                                                                                    :placeholder="
                                                                                        $t(
                                                                                            'enter_file_value'
                                                                                        )
                                                                                    "
                                                                                    size="sm"
                                                                                    :value.sync="
                                                                                        item.value
                                                                                    "
                                                                                />
                                                                            </template>
                                                                            <template
                                                                                #options="{
                                                                                    item,
                                                                                }"
                                                                            >
                                                                                <ButtonTrash
                                                                                    @click="
                                                                                        deleteItemToFieldAdapterTable(
                                                                                            index,
                                                                                            item.uuid
                                                                                        )
                                                                                    "
                                                                                />
                                                                            </template>
                                                                        </CustomTable>
                                                                    </CCol>
                                                                </CRow>
                                                            </CCardBody>
                                                        </CCollapse>
                                                    </template>

                                                    <!-- Values request header  -->
                                                    <template
                                                        #headerName="{ index }"
                                                    >
                                                        <CInput
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    api_configuration.key,
                                                                    'headerName',
                                                                    index
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables[
                                                                    api_configuration
                                                                        .key
                                                                ].items.$each[
                                                                    index
                                                                ]['headerName']
                                                                    .$model
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'enter_the_header_name'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'header_name_is_required'
                                                                )
                                                            "
                                                            size="sm"
                                                        />
                                                    </template>
                                                    <template
                                                        #headerValue="{ index }"
                                                    >
                                                        <CInput
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    api_configuration.key,
                                                                    'headerValue',
                                                                    index
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables[
                                                                    api_configuration
                                                                        .key
                                                                ].items.$each[
                                                                    index
                                                                ]['headerValue']
                                                                    .$model
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'enter_the_header_value'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'header_value_is_required'
                                                                )
                                                            "
                                                            size="sm"
                                                        />
                                                    </template>

                                                    <!-- 
                                                        Capping responses && 
                                                        Ok responses && 
                                                        Ko responses && 
                                                        Duplication responses && 
                                                        Duplication header && 
                                                        Ok header (only value) && 
                                                        Capping header (only value) &&
                                                        Ko header (only value) &&
                                                        Run pixel on ok (only value)
                                                    -->
                                                    <template
                                                        #condition="{ index }"
                                                    >
                                                        <CSelect
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    api_configuration.key,
                                                                    'condition',
                                                                    index
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables[
                                                                    api_configuration
                                                                        .key
                                                                ].items.$each[
                                                                    index
                                                                ]['condition']
                                                                    .$model
                                                            "
                                                            :options="
                                                                traslateLabels(
                                                                    $options
                                                                        .options
                                                                        .filterType
                                                                )
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'select_a_condition'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'condition_is_required'
                                                                )
                                                            "
                                                            size="sm"
                                                        />
                                                    </template>
                                                    <template
                                                        #value="{ index }"
                                                    >
                                                        <CInput
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    api_configuration.key,
                                                                    'value',
                                                                    index
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables[
                                                                    api_configuration
                                                                        .key
                                                                ].items.$each[
                                                                    index
                                                                ]['value']
                                                                    .$model
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'enter_the_value'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'value_is_required'
                                                                )
                                                            "
                                                            size="sm"
                                                        />
                                                    </template>
                                                </CustomTable>
                                            </CCardBody>
                                            <CCardFooter
                                                v-if="
                                                    api_configuration.type ==
                                                        'table' &&
                                                    tables[
                                                        api_configuration.key
                                                    ].items.length > 0
                                                "
                                            >
                                                <ButtonAdd
                                                    @click="
                                                        addItemToTable(
                                                            api_configuration.key
                                                        )
                                                    "
                                                />
                                            </CCardFooter>
                                        </CCard>
                                    </CTab>
                                    <CTab
                                        :title="$t('email_configuration')"
                                        :disabled="
                                            $v.form.shipping_method.$model !=
                                            '25e002d8-c055-4d57-8be1-cba76eb56a21'
                                        "
                                    >
                                        <CCard
                                            v-for="(
                                                email_configuration, index
                                            ) in email_configuration_list"
                                            :key="index"
                                            class="my-4"
                                        >
                                            <CCardHeader>
                                                {{
                                                    $t(
                                                        email_configuration.label
                                                    )
                                                }}
                                            </CCardHeader>
                                            <!-- Shipping format -->
                                            <CCardBody>
                                                <h6
                                                    v-if="
                                                        email_configuration.description
                                                    "
                                                >
                                                    {{
                                                        $t(
                                                            email_configuration.description
                                                        )
                                                    }}
                                                </h6>
                                                <TagsInput
                                                    v-if="
                                                        email_configuration.type ==
                                                        'list'
                                                    "
                                                    :label="
                                                        $t(
                                                            email_configuration.label
                                                        )
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    :value.sync="
                                                        form[
                                                            email_configuration
                                                                .key
                                                        ]
                                                    "
                                                />
                                                <div
                                                    v-else-if="
                                                        email_configuration.type ==
                                                        'object'
                                                    "
                                                >
                                                    <div
                                                        v-for="(
                                                            value, key
                                                        ) in form[
                                                            email_configuration
                                                                .key
                                                        ]"
                                                        :key="key"
                                                    >
                                                        <LInputRadioGroup
                                                            v-if="
                                                                typeof form[
                                                                    email_configuration
                                                                        .key
                                                                ][key] ==
                                                                'boolean'
                                                            "
                                                            :checked.sync="
                                                                form[
                                                                    email_configuration
                                                                        .key
                                                                ][key]
                                                            "
                                                            :options="[
                                                                {
                                                                    value: true,
                                                                    label: 'Yes',
                                                                },
                                                                {
                                                                    value: false,
                                                                    label: 'No',
                                                                },
                                                            ]"
                                                            size="sm"
                                                            :label="$t(key)"
                                                            :inline="true"
                                                            :horizontal="
                                                                default_horizontal
                                                            "
                                                        />
                                                        <InputPassword
                                                            v-else-if="
                                                                key ==
                                                                'password'
                                                            "
                                                            :value.sync="
                                                                form[
                                                                    email_configuration
                                                                        .key
                                                                ][key]
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'Enter a password'
                                                                )
                                                            "
                                                            :label="$t(key)"
                                                            :horizontal="
                                                                default_horizontal
                                                            "
                                                            :autocomplete="
                                                                false
                                                            "
                                                            size="sm"
                                                        />

                                                        <InputList
                                                            v-else-if="
                                                                typeof form[
                                                                    email_configuration
                                                                        .key
                                                                ][key] ==
                                                                    'object' &&
                                                                Array.isArray(
                                                                    form[
                                                                        email_configuration
                                                                            .key
                                                                    ][key]
                                                                )
                                                            "
                                                            :value.sync="
                                                                form[
                                                                    email_configuration
                                                                        .key
                                                                ][key]
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'enter_the_value'
                                                                )
                                                            "
                                                            :label="$t(key)"
                                                            :horizontal="
                                                                default_horizontal
                                                            "
                                                            size="sm"
                                                        />
                                                        <CInput
                                                            v-else
                                                            :value.sync="
                                                                form[
                                                                    email_configuration
                                                                        .key
                                                                ][key]
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'enter_the_value'
                                                                )
                                                            "
                                                            :label="$t(key)"
                                                            :horizontal="
                                                                default_horizontal
                                                            "
                                                            size="sm"
                                                        />
                                                    </div>
                                                </div>
                                                <TableFixedFields
                                                    v-else-if="
                                                        email_configuration.type ==
                                                        'TableFixedFields'
                                                    "
                                                    :value.sync="
                                                        tables[
                                                            email_configuration
                                                                .key
                                                        ].items
                                                    "
                                                />
                                                <TableMappingFields
                                                    v-else-if="
                                                        email_configuration.type ==
                                                        'TableMappingFields'
                                                    "
                                                    :value.sync="
                                                        tables[
                                                            email_configuration
                                                                .key
                                                        ].items
                                                    "
                                                />
                                                <CDataTable
                                                    v-else-if="
                                                        email_configuration.type ==
                                                        'table'
                                                    "
                                                    :addTableClasses="[
                                                        'table--sm',
                                                    ]"
                                                    :items="
                                                        tables[
                                                            email_configuration
                                                                .key
                                                        ].items
                                                    "
                                                    :fields="
                                                        traslateLabels(
                                                            tables[
                                                                email_configuration
                                                                    .key
                                                            ].fields
                                                        )
                                                    "
                                                    hover
                                                    border
                                                    striped
                                                >
                                                    <!-- Options -->
                                                    <template
                                                        #options="{ index }"
                                                    >
                                                        <td
                                                            class="py-2 text-center"
                                                        >
                                                            <ButtonTrash
                                                                @click="
                                                                    deleteItemToTable(
                                                                        email_configuration.key,
                                                                        index
                                                                    )
                                                                "
                                                            />
                                                        </td>
                                                    </template>
                                                    <template #under-table>
                                                        <ButtonAdd
                                                            @click="
                                                                addItemToTable(
                                                                    email_configuration.key
                                                                )
                                                            "
                                                        />
                                                    </template>

                                                    <!-- No items view -->
                                                    <template #no-items-view>
                                                        <div
                                                            class="block-no-items section"
                                                        >
                                                            <h2
                                                                class="text-no-items section__title"
                                                            >
                                                                {{
                                                                    $t(
                                                                        "add_configuration"
                                                                    )
                                                                }}
                                                            </h2>
                                                            <ButtonAdd
                                                                @click="
                                                                    addItemToTable(
                                                                        email_configuration.key
                                                                    )
                                                                "
                                                            />
                                                        </div>
                                                    </template>
                                                    <template #key="{ index }">
                                                        <td>
                                                            <SelectFields
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        email_configuration.key,
                                                                        'key',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        email_configuration
                                                                            .key
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ]['key']
                                                                        .$model
                                                                "
                                                                v-bind="
                                                                    defaultSelectInTableConfig
                                                                "
                                                                :advanceMode="
                                                                    stringToBoolean(
                                                                        form.advance_validation
                                                                    )
                                                                "
                                                                uses="DELIVERY"
                                                                optionsValue="code"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template #name="{ index }">
                                                        <td>
                                                            <CInput
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        email_configuration.key,
                                                                        'name',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        email_configuration
                                                                            .key
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ]['name']
                                                                        .$model
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'enter_the_value'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'value_is_required'
                                                                    )
                                                                "
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template
                                                        #value="{ index }"
                                                    >
                                                        <td>
                                                            <CInput
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        email_configuration.key,
                                                                        'value',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        email_configuration
                                                                            .key
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ]['value']
                                                                        .$model
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'enter_the_value'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'value_is_required'
                                                                    )
                                                                "
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>
                                                </CDataTable>
                                                <CTextarea
                                                    v-else-if="
                                                        email_configuration.type ==
                                                        'textarea'
                                                    "
                                                    :value.sync="
                                                        form[
                                                            email_configuration
                                                                .key
                                                        ]
                                                    "
                                                    :placeholder="
                                                        $t('enter_the_value')
                                                    "
                                                    :label="
                                                        $t(
                                                            email_configuration.label
                                                        )
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    size="sm"
                                                    rows="10"
                                                />
                                                <CCSwitch
                                                    v-else-if="
                                                        email_configuration.type ==
                                                        'switch'
                                                    "
                                                    :checked.sync="
                                                        form[
                                                            email_configuration
                                                                .key
                                                        ]
                                                    "
                                                    :label="
                                                        $t(
                                                            email_configuration.label
                                                        )
                                                    "
                                                    :horizontal="{
                                                        label: 'col-sm-2',
                                                        input: 'col-sm-10',
                                                    }"
                                                    color="primary"
                                                    name="action"
                                                    shape="pill"
                                                    variant="3d"
                                                    size="sm"
                                                />
                                                <CInput
                                                    v-else
                                                    :value.sync="
                                                        form[
                                                            email_configuration
                                                                .key
                                                        ]
                                                    "
                                                    :placeholder="
                                                        $t('enter_the_value')
                                                    "
                                                    :label="
                                                        $t(
                                                            email_configuration.label
                                                        )
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    size="sm"
                                                />
                                            </CCardBody>
                                        </CCard>
                                    </CTab>
                                    <CTab
                                        :title="$t('sftp_configuration')"
                                        :disabled="
                                            $v.form.shipping_method.$model !=
                                            '6d5eb8dc-f006-4b09-b914-09fa17c6bf59'
                                        "
                                    >
                                        <CCMethodSftpConfiguration
                                            :value.sync="
                                                methodSftpConfiguration
                                            "
                                            size="sm"
                                        />
                                    </CTab>
                                    <CTab
                                        :title="
                                            $t('api_download_configuration')
                                        "
                                        :disabled="
                                            $v.form.shipping_method.$model !=
                                            '1346c8a9-d04e-4ba2-b4ec-0142e706cfa6'
                                        "
                                    >
                                        <CCMethodApiDownloadConfiguration
                                            :value="
                                                methodApiDownloadConfiguration
                                            "
                                        />
                                    </CTab>
                                </CTabs>
                            </CCardBody>
                            <CCardFooter class="d-flex">
                                <ButtonSave @click="sendForm()" />
                                <ButtonBack class="mr-3" title="Go back" />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import VueTagsInput from "@johmun/vue-tags-input";
import TitlePage from "£lement/titlePage";
import ButtonSave from "~/components/ButtonSave.vue";
import TagsInput from "~/components/TagsInput.vue";
import ButtonAdd from "~/components/ButtonAdd.vue";
import CCSwitch from "~/components/CCSwitch.vue";
import ButtonClose from "~/components/ButtonClose.vue";
import ButtonTrash from "~/components/ButtonTrash.vue";
import SelectCountry from "£lement/SelectCountry";
import SelectAsync from "£lement/SelectAsync";
import SelectFields from "£lement/SelectFields";
import SelectFieldsAdvance from "£lement/SelectFieldsAdvance";
import ButtonBack from "£lement/ButtonBack";
import LInputRadioGroup from "~/components/LInputRadioGroup";
import LCodeEditor from "~/components/LCodeEditor";
import ButtonBulk from "~/components/ButtonBulk";
import InputPassword from "~/components/InputPassword";
import InputList from "~/components/InputList";
import CustomTable from "~/components/CustomTable";
import CCMethodApiDownloadConfiguration from "../components/CCMethodApiDownloadConfiguration";
import CCMultiFieldMapping from "../components/CCMultiFieldMapping";
import CCInputExtraTime from "../components/CCInputExtraTime";
import FormSectionDescription from "~/components/FormSectionDescription.vue";
import FormSection from "~/components/FormSection.vue";
import SelectTags from "£lement/SelectTags";

/** Mixins */
import { validationMixin } from "vuelidate";
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import modalMixin from "~/mixins/modal.js";

import DateFormat from "~/assets/options/date_format.json";
import TimeFormat from "~/assets/options/time_format.json";
import MappingFormatType from "~/assets/options/mapping_format_type.json";
import ResponseOkTable from "../config/tables/response_ok";
import ColumnsTable from "../config/tables/columns";
import ResponseKoTable from "../config/tables/response_ko";
import ResponseDupTable from "../config/tables/response_dup";
import HeaderDupTable from "../config/tables/header_dup";
import HeadersTable from "../config/tables/headers";
import MappingTable from "../config/tables/mapping";
import MappingFieldsEmailConfiguration from "../config/tables/MappingFieldsEmailConfiguration";
import FixedFieldsEmailConfiguration from "../config/tables/FixedFieldsEmailConfiguration";
import QueryParamsTable from "../config/tables/query_params";
import HeaderOkTable from "../config/tables/header_ok";
import HeaderKoTable from "../config/tables/header_ko";
import ActionFilterTable from "../config/tables/action_filter";
import FilterTypeOptions from "../config/options/filter_type";
import OptionsListModal from "../config/modals/options_list";
import FieldTypeOptions from "../config/options/field_type.js";
import MethodOptions from "../config/options/method.js";
import ShippingFormatOptions from "../config/options/shipping_format.js";
import TableFixedFields from "~/components/TableFixedFields.vue";
import TableMappingFields from "~/components/TableMappingFields.vue";
import weekDaysOptions from "../config/options/week_days.js";

/** Others */
import {
    cilSave,
    cilArrowThickFromRight,
    cilPencil,
    cilSettings,
} from "@coreui/icons";
import { required, requiredIf, between } from "vuelidate/lib/validators";
import Swal from "sweetalert2";

import {
    METHOD_API_DOWNLOAD_CONFIGURATION,
    METHOD_API_CONFIGURATION,
} from "~/pages/app/integration/config";
import CCMethodSftpConfiguration from "../components/CCMethodSftpConfiguration.vue";

export default {
    name: "IntegrationViewPage",
    middleware: ["auth", "page"],
    mixins: [validationMixin, pageMixin, modalMixin, tableMixin],
    components: {
        TitlePage,
        SelectCountry,
        SelectAsync,
        SelectFields,
        SelectFieldsAdvance,
        LCodeEditor,
        ButtonBack,
        LInputRadioGroup,
        ButtonSave,
        ButtonClose,
        ButtonAdd,
        ButtonTrash,
        ColumnsTable,
        VueTagsInput,
        TagsInput,
        TableFixedFields,
        TableMappingFields,
        ButtonBulk,
        InputPassword,
        CustomTable,
        InputList,
        CCMethodApiDownloadConfiguration,
        CCMethodSftpConfiguration,
        CCMultiFieldMapping,
        CCInputExtraTime,
        CCSwitch,
        FormSection,
        FormSectionDescription,
        SelectTags
    },
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilPencil,
        cilSettings,
    },
    consts: {
        METHOD_API_DOWNLOAD_CONFIGURATION,
        METHOD_API_CONFIGURATION,
    },
    options: {
        filterType: FilterTypeOptions,
        dateFormat: DateFormat,
        timeFormat: TimeFormat,
        mappingFormatType: MappingFormatType,
        shippingFormat: ShippingFormatOptions,
        methods: MethodOptions,
        FieldTypeOptions,
        weekDays: weekDaysOptions,
    },
    data() {
        return {
            methodSftpConfiguration: {
                to: [],
                cc: [],
                cco: [],
                subjectUploadNotification: "",
                subjectPassword: "",
                messageUploadNotification: "",
                messagePassword: "",
                signature: "",
                isHtml: false,
                file: {
                    name: null,
                    format: null,
                    delimiter: null,
                    enclosure: null,
                    compressed: false,
                    password: null,
                },
                fixedFields: [],
                mappingFields: [],
            },
            methodApiDownloadConfiguration: {
                fixedFields: [],
                mappingFields: [],
            },
            formFieldOldPassword: "",
            form: {
                name: null,
                advance_validation: false,
                shipping_method: "c56eeb8a-07fc-4d5f-9a6d-e23608179f38",
                daily_hour_execute: null,
                week_days_execute: "[]",
                type: null,
                method: null,
                url: null,
                sendFormat: null,
                payloadContent: null,
                payloadActive: false,
                multiFieldMapping: [],
                isHtml: false,
                subject: null,
                subjectPassword: null,
                body: null,
                message: null,
                messagePassword: null,
                signature: null,
                to: [],
                cco: [],
                cc: [],
                file: {
                    name: null,
                    format: null,
                    delimiter: null,
                    enclosure: null,
                    compressed: false,
                    password: null,
                },
            },
            api_configuration_list: [
                {
                    key: "configuration_endpoint",
                    label: "configuration_endpoint",
                    description: "",
                    type: "input",
                },
                {
                    key: "shipping_format",
                    label: "shipping_format",
                    description: "",
                    type: "input",
                },
                {
                    key: "queryParams",
                    label: "fixed_parameters",
                    description: "fixed_parameters_description",
                    type: "table",
                },
                {
                    key: "mapping",
                    label: "variable_parameters",
                    description: "variable_parameters_description",
                    type: "table",
                },
                {
                    key: "multiFieldMapping",
                    label: "Multi Field Mapping",
                    description:
                        "Allows you to combine multiple input fields and apply various operations to generate a single output value.",
                    type: "CCMultiFieldMapping",
                },
                {
                    key: "payload",
                    label: "payload",
                    description: "",
                    type: "input",
                },
                {
                    key: "responseOK",
                    label: "ok_responses",
                    description: "response_ok",
                    type: "table",
                },
                {
                    key: "responseKO",
                    label: "ko_responses",
                    description: "response_ko",
                    type: "table",
                },
                {
                    key: "responseDUP",
                    label: "duplication_responses",
                    description: "response_duplicates",
                    type: "table",
                },
                {
                    key: "headers",
                    label: "values_request_header",
                    description: "",
                    type: "table",
                },
                {
                    key: "headerOK",
                    label: "ok_header",
                    description: "",
                    type: "table",
                },
                {
                    key: "headerKO",
                    label: "ko_header",
                    description: "",
                    type: "table",
                },
                {
                    key: "headerDUP",
                    label: "duplication_header",
                    description: "",
                    type: "table",
                },
            ],
            email_configuration_list: [
                {
                    key: "to",
                    label: "to",
                    type: "list",
                },
                {
                    key: "cc",
                    label: "cc",
                    type: "list",
                },
                {
                    key: "cco",
                    label: "cco",
                    type: "list",
                },
                {
                    key: "subject",
                    label: "subject",
                    type: "input",
                },
                {
                    key: "subjectPassword",
                    label: "subject_password",
                    type: "input",
                },
                {
                    key: "isHtml",
                    label: "is_html",
                    type: "switch",
                },
                {
                    key: "message",
                    label: "message",
                    type: "textarea",
                },
                {
                    key: "messagePassword",
                    label: "message_password",
                    type: "textarea",
                },
                {
                    key: "signature",
                    label: "signature",
                    type: "textarea",
                },
                // {
                //     key: "body",
                //     label: "body",
                //     type: "textarea",
                // },
                {
                    key: "file",
                    label: "file_configuration",
                    type: "object",
                },
                {
                    key: "mappingFieldsEmailConfiguration",
                    label: "mapping_fields",
                    description: "variable_parameters_description",
                    type: "TableMappingFields",
                },
                {
                    key: "fixedFieldsEmailConfiguration",
                    label: "fixed_fields",
                    description: "fixed_parameters_description",
                    type: "TableFixedFields",
                },
                // {
                //     key: "columns",
                //     label: "columns",
                //     description: "columns_description",
                //     type: "table",
                // },
            ],
            tables: {
                actionFilter: ActionFilterTable,
                queryParams: QueryParamsTable,
                mapping: MappingTable,
                mappingFieldsEmailConfiguration:
                    MappingFieldsEmailConfiguration,
                fixedFieldsEmailConfiguration: FixedFieldsEmailConfiguration,
                headers: HeadersTable,
                responseOK: ResponseOkTable,
                responseKO: ResponseKoTable,
                responseDUP: ResponseDupTable,
                headerDUP: HeaderDupTable,
                headerOK: HeaderOkTable,
                headerKO: HeaderKoTable,
                columns: ColumnsTable,
            },
            modals: {
                optionsList: OptionsListModal,
            },
        };
    },
    computed: {
        workflow_id: function () {
            return this.$route.query.workflow_id;
        },
        client_id: function () {
            return this.$route.query.client_id;
        },
        view_type: function () {
            return this.$route.query.view_type;
        },
        payloadContent: {
            get() {
                return this.$v.form.payloadContent.$model
                    ? JSON.stringify(
                          this.$v.form.payloadContent.$model,
                          undefined,
                          4
                      )
                    : "";
            },
            set(value) {
                this.$v.form.payloadContent.$model = value
                    ? JSON.parse(value)
                    : value;
            },
        },
        weekDaysExecute: {
            get() {
                let weekDays = JSON.parse(this.form.week_days_execute);

                let weekDaysOptions = this.$options.options.weekDays;
                let weekDaysOptionsFiltered = [];

                weekDaysOptions.forEach((weekDay) => {
                    if (
                        weekDays &&
                        weekDays.find((toFind) => toFind == weekDay.value)
                    ) {
                        weekDaysOptionsFiltered.push(weekDay);
                    }
                });
                return weekDaysOptionsFiltered;
            },
            set(value) {
                let weekDays = [];
                value.forEach(function (weekDay) {
                    weekDays.push(weekDay.value);
                });
                this.form.week_days_execute = JSON.stringify(weekDays);
            },
        },
    },
    validations: {
        form: {
            name: {
                required,
            },
            advance_validation: {},
            shipping_method: {},
            daily_hour_execute: {
                required: requiredIf(function (nestedModel) {
                    return (
                        nestedModel.shipping_method ===
                        "25e002d8-c055-4d57-8be1-cba76eb56a21"
                    );
                }),
                between: between(0, 23),
            },
            week_days_execute: {
                required: requiredIf(function (nestedModel) {
                    return (
                        nestedModel.shipping_method ===
                            "25e002d8-c055-4d57-8be1-cba76eb56a21" ||
                        nestedModel.shipping_method ===
                            "6d5eb8dc-f006-4b09-b914-09fa17c6bf59"
                    );
                }),
            },
            method: {
                required: requiredIf(function (nestedModel) {
                    return (
                        nestedModel.shipping_method === METHOD_API_CONFIGURATION
                    );
                }),
            },
            url: {
                required: requiredIf(function (nestedModel) {
                    return (
                        nestedModel.shipping_method === METHOD_API_CONFIGURATION
                    );
                }),
            },
            sendFormat: {
                required: requiredIf(function (nestedModel) {
                    return (
                        nestedModel.shipping_method === METHOD_API_CONFIGURATION
                    );
                }),
            },
            payloadContent: {
                required: requiredIf(function (nestedModel) {
                    return nestedModel.payloadActive === true;
                }),
            },
            payloadActive: {
                required,
            },
        },
        tables: {
            actionFilter: {
                items: {
                    $each: {
                        condition: {
                            required,
                        },
                        fieldName: {
                            required,
                        },
                        fieldType: {
                            required,
                        },
                        value: {
                            required,
                        },
                    },
                },
            },
            mappingFieldsEmailConfiguration: {
                items: {
                    $each: {
                        name: {},
                        key: {
                            required,
                        },
                    },
                },
            },
            fixedFieldsEmailConfiguration: {
                items: {
                    $each: {
                        name: {
                            required,
                        },
                        value: {
                            required,
                        },
                    },
                },
            },
            queryParams: {
                items: {
                    $each: {
                        queryName: {
                            required,
                        },
                        queryMethod: {
                            required,
                        },
                        queryValue: {
                            required,
                        },
                    },
                },
            },
            mapping: {
                items: {
                    $each: {
                        fieldMappingId: {
                            required,
                        },
                        fieldMappingMethod: {},
                        fieldMappingValue: {},
                        fieldActiveFormat: {},
                        fieldMappingFormatType: {},
                        fieldMappingFormatDateType: {},
                        convertDateTimeZone: {},
                        addTimeToDate: {
                            $each: {
                                days: {},
                                months: {},
                                years: {},
                            },
                        },
                        fieldMappingFormatHourType: {},
                        fieldMappingMask: {},
                        fieldMappingValueReplace: {},
                        fieldAdapter: {
                            $each: {
                                name: {
                                    // required,
                                },
                                value: {
                                    required,
                                },
                            },
                        },
                    },
                },
            },
            headers: {
                items: {
                    $each: {
                        headerName: {
                            required,
                        },
                        headerValue: {
                            required,
                        },
                    },
                },
            },
            responseOK: {
                items: {
                    $each: {
                        condition: {
                            required,
                        },
                        value: {
                            required,
                        },
                    },
                },
            },
            responseKO: {
                items: {
                    $each: {
                        condition: {
                            required,
                        },
                        value: {
                            required,
                        },
                    },
                },
            },
            responseDUP: {
                items: {
                    $each: {
                        condition: {
                            required,
                        },
                        value: {
                            required,
                        },
                    },
                },
            },
            headerDUP: {
                items: {
                    $each: {
                        value: {
                            required,
                        },
                    },
                },
            },
            headerOK: {
                items: {
                    $each: {
                        value: {
                            required,
                        },
                    },
                },
            },
            headerKO: {
                items: {
                    $each: {
                        value: {
                            required,
                        },
                    },
                },
            },
        },
    },
    methods: {
        getFilterCondition(index) {
            return this.$v.tables["actionFilter"].items.$each[index].condition
                .$model;
        },
        initModalOptionsList(modal) {
            this.modals.optionsList.data.optionsValue =
                this.tables.actionFilter.items[modal.data.idItemSelected].value;
        },
        saveOptionsList() {
            this.tables.actionFilter.items[
                this.modals.optionsList.data.idItemSelected
            ].value = this.modals.optionsList.data.optionsValue;
            this.modals.optionsList.show = false;
        },
        checkIfFormTableValid(tableName, fieldName, index) {
            let field = this.$v.tables[tableName].items.$each[index][fieldName];
            if (!field.$dirty) {
                return null;
            }
            return !(field.$invalid || field.$model === "");
        },
        sendForm: async function () {
            this.updatePageLoading(true);
            this.$v.$touch();
            try {
                if (this.$v.$invalid) {
                    throw { code: 422, message: this.$t("invalid_data") };
                }

                let continueSendForm = true;
                if (
                    this.view_type &&
                    this.view_type == "edit" &&
                    this.formFieldOldPassword != this.form.file.password
                ) {
                    let result = await Swal.fire({
                        title: this.$t(
                            "Are you sure you want to change the password?"
                        ),
                        text: this.$t(
                            "We have detected that you have changed the password and we want to verify that you really want to change it."
                        ),
                        icon: "warning",
                        showDenyButton: true,
                        showCancelButton: true,
                        confirmButtonColor: "#218838",
                        denyButtonColor: "#3085d6",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: this.$t("Save"),
                        denyButtonText: this.$t("Save with old password"),
                        cancelButtonText: this.$t("Don't save"),
                    });
                    if (result.isDenied) {
                        this.form.file.password = this.formFieldOldPassword;
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        continueSendForm = false;
                    }
                }

                if (continueSendForm) {
                    let methodApi;
                    for (const key in this.tables) {
                        if (Object.hasOwnProperty.call(this.tables, key)) {
                            let table = this.tables[key];
                            let items = table.items;
                            if (key == "mapping") {
                                items = table.items.map((item) => {
                                    return {
                                        ...item,
                                        fieldActiveFormat:
                                            item.fieldActiveFormat
                                                ? "on"
                                                : "off",
                                    };
                                });
                            }
                            methodApi = {
                                ...methodApi,
                                [key]: items,
                            };
                        }
                    }

                    delete methodApi.actionFilter;
                    delete methodApi.columns;

                    let form = {
                        name: this.form.name,
                        advance_validation: this.form.advance_validation,
                        shipping_method: this.form.shipping_method,
                        daily_hour_execute: this.form.daily_hour_execute,
                        week_days_execute: this.form.week_days_execute,
                        workflow_metadata: {
                            origin: [
                                {
                                    trigger: [
                                        {
                                            action: [
                                                {
                                                    actionFilter: {
                                                        fieldFilter:
                                                            this.tables
                                                                .actionFilter
                                                                .items,
                                                    },
                                                    type: "SENDLEAD",
                                                    actionSendlead: {
                                                        methodApi: {
                                                            ...methodApi,
                                                            url: this.form.url,
                                                            method: this.form
                                                                .method,
                                                            multiFieldMapping:
                                                                this.form
                                                                    .multiFieldMapping,
                                                            payload: {
                                                                content:
                                                                    JSON.stringify(
                                                                        this
                                                                            .form
                                                                            .payloadContent,
                                                                        undefined,
                                                                        4
                                                                    ), //
                                                                active: this
                                                                    .form
                                                                    .payloadActive,
                                                            },
                                                            fieldValues: [],
                                                            tenantId: null,
                                                            clientId: null,
                                                            responseFormat:
                                                                null,
                                                            sendFormat:
                                                                this.form
                                                                    .sendFormat, //To replace
                                                            debug: 0,
                                                        },
                                                        methodEmail: {
                                                            to: this.form.to,
                                                            cc: this.form.cc,
                                                            cco: this.form.cco,
                                                            subject:
                                                                this.form
                                                                    .subject,
                                                            subjectPassword:
                                                                this.form
                                                                    .subjectPassword,
                                                            isHtml: this.form
                                                                .isHtml,
                                                            body: this.form
                                                                .body,
                                                            message:
                                                                this.form
                                                                    .message,
                                                            messagePassword:
                                                                this.form
                                                                    .messagePassword,
                                                            signature:
                                                                this.form
                                                                    .signature,
                                                            file: this.form
                                                                .file,
                                                            isHtml: this.form
                                                                .isHtml,
                                                            mappingFields:
                                                                this.tables
                                                                    .mappingFieldsEmailConfiguration
                                                                    .items,
                                                            fixedFields:
                                                                this.tables
                                                                    .fixedFieldsEmailConfiguration
                                                                    .items,
                                                        },
                                                        methodSftp:
                                                            this
                                                                .methodSftpConfiguration,
                                                        methodApiDownload:
                                                            this
                                                                .methodApiDownloadConfiguration,
                                                    },
                                                },
                                            ],
                                            type: "ARRIVAL_LEAD_WITHOUT_FORM",
                                        },
                                    ],
                                    type: "ALL",
                                },
                            ],
                        },
                    };

                    let url =
                        this.view_type == "new"
                            ? `/campaigns.api/${this.client_id}/workflows/create`
                            : `/campaigns.api/${this.client_id}/workflows/${this.workflow_id}/update`;
                    let method = this.view_type == "new" ? "POST" : "PUT";

                    await this.sendData({
                        data: form,
                        url,
                        method,
                    });

                    if (this.view_type == "edit") {
                        this.$store.dispatch("toast/addFixedToasts", {
                            ...this.$options.messages.update,
                        });
                    } else {
                        this.$store.dispatch("toast/addFixedToasts", {
                            ...this.$options.messages.create,
                        });
                    }

                    this.$router.go(-1);
                }
            } catch (error) {
                this.showMessageError(error);
            }
            this.updatePageLoading(false);
        },
        async loadForm(formData) {
            let actionFilter = [];
            let action =
                formData.workflow_metadata.origin[0].trigger[0].action[0];

            if (action.actionFilter.fieldFilter)
                actionFilter = action.actionFilter.fieldFilter;
            let methodApi = action.actionSendlead.methodApi;
            let methodEmail = action.actionSendlead.methodEmail;
            this.methodSftpConfiguration = action.actionSendlead.methodSftp;
            this.methodApiDownloadConfiguration =
                action.actionSendlead.methodApiDownload;

            let formMethodEmail = {};

            if (action.actionSendlead.methodEmail) {
                formMethodEmail = {
                    to: methodEmail.to,
                    cc: methodEmail.cc,
                    cco: methodEmail.cco,
                    subject: methodEmail.subject,
                    subjectPassword: methodEmail.subjectPassword,
                    isHtml: methodEmail.isHtml,
                    body: methodEmail.body,
                    message: methodEmail.message,
                    messagePassword: methodEmail.messagePassword,
                    signature: methodEmail.signature,
                    file: methodEmail.file,
                };

                this.tables.mappingFieldsEmailConfiguration.items = [
                    ...methodEmail.mappingFields,
                ];
                this.tables.fixedFieldsEmailConfiguration.items = [
                    ...methodEmail.fixedFields,
                ];
            }

            let formMethodApi = {};

            if (action.actionSendlead.methodApi) {
                let payload = action.actionSendlead.methodApi.payload;
                let payloadContent;
                if (payload && payload.content) {
                    payloadContent = JSON.parse(payload.content);
                }
                let payloadActive = false;
                if (payload && payload.active) {
                    payloadActive = payload.active;
                }
                formMethodApi = {
                    method: methodApi.method,
                    url: methodApi.url,
                    sendFormat: methodApi.sendFormat,
                    payloadContent: payloadContent,
                    payloadActive: payloadActive,
                    multiFieldMapping: methodApi.multiFieldMapping,
                };

                for (const key in methodApi) {
                    if (
                        Object.hasOwnProperty.call(methodApi, key) &&
                        Object.hasOwnProperty.call(this.tables, key)
                    ) {
                        let data = methodApi[key];
                        if (key == "mapping") {
                            data = data.map((item) => {
                                return {
                                    ...item,
                                    fieldActiveFormat:
                                        item.fieldActiveFormat == "on"
                                            ? true
                                            : false,
                                };
                            });
                        }
                        this.tables[key].items = data;
                    }
                }
            }

            this.form = {
                ...this.form,
                name: formData.name,
                advance_validation: formData.advance_validation,
                shipping_method: formData.shipping_method,
                daily_hour_execute: formData.daily_hour_execute,
                week_days_execute: formData.week_days_execute,
                ...formMethodApi,
                ...formMethodEmail,
            };
            this.formFieldOldPassword = this.form.file.password;

            this.tables.actionFilter.items = actionFilter;
        },
        async updateForm() {
            if (this.view_type && this.view_type == "edit") {
                let formData = await this.loadData({
                    url: `/campaigns.api/${this.client_id}/workflow`,
                });
                this.loadForm(formData._items);
            }
            this.updatePageLoading(false);
        },

        addItemToFieldAdapterTable(index) {
            let mappingItems = [...this.tables.mapping.items];
            if (!mappingItems[index].fieldAdapter) {
                mappingItems[index] = {
                    ...mappingItems[index],
                    fieldAdapter: [],
                };
            }
            if (Array.isArray(mappingItems[index].fieldAdapter)) {
                mappingItems[index].fieldAdapter.push({
                    uuid: this.generateUUID(),
                    name: null,
                    value: null,
                });
            } else {
                mappingItems[index].fieldAdapter = [
                    {
                        uuid: this.generateUUID(),
                        name: null,
                        value: null,
                    },
                ];
            }

            this.tables.mapping.items = mappingItems;
        },
        deleteItemToFieldAdapterTable(index, adapterUuid) {
            let findAdapter = this.tables.mapping.items[
                index
            ].fieldAdapter.findIndex((adapter) => adapter.uuid == adapterUuid);

            if (findAdapter == 0) {
                this.tables.mapping.items[index].fieldAdapter.splice(0, 1);
            } else if (findAdapter > 0) {
                this.tables.mapping.items[index].fieldAdapter.splice(
                    findAdapter,
                    1
                );
            }
        },
        toggleDetails(tableName, index) {
            let item = this.tables[tableName].items[index];
            this.$set(
                this.tables[tableName].items[index],
                "_toggled",
                !item._toggled
            );
        },
    },
    mounted() {
        this.updateForm();
    },
    created() {
        this.loadFields();
        this.loadFieldsAdvance();
    },
};
</script>

<style scoped lang="scss">
.custom-btn {
    & .icon {
        color: white;
        display: inline-block;
        margin: 0.5rem 0.75rem;
    }
    & .text {
        margin-right: 1rem;
    }
}
</style>
